import React, { useRef, useState, useEffect, useContext } from "react";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import OButton from "components/reusable/OButton";
import { apiPost } from "utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { apiGet } from "../../utils/apiFetch";
import helpers from "../../utils/helpers";
import AuthContext from "context/AuthContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import OTextArea from "components/reusable/OTextArea";
import noImage from "../../assets/images/No-image-found.jpg";
import ErrorMessage from "components/ErrorMessage";
import { MdCancel } from "react-icons/md";
import useToastContext from "hooks/useToastContext";

const SideAdsBanner = ({ addHomeBanner, manager }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerImageError, setBannerImageError] = useState("");
  const [mobileBannerImage, setBannerMobileImage] = useState(null);
  const [bannerMobileImageError, setBannerMobileImageError] = useState("");
  const notification = useToastContext();
  const bannerImageRef = useRef();
  const bannerMobileImageRef = useRef();
  const [sidesBanner, setSideBanner] = useState([]);
  const [isBuy, setIsBuy] = useState(false);
  const [isRent, setIsRent] = useState(false);
  const [isCommercial, setIsCommercial] = useState(false);
  const [propertyDetail, setPropertyDetail] = useState(false);
  const [projectDetail, setProjectDetail] = useState(false);
  const [projectList, setProjectList] = useState(false);
  const [agentDetail, setAgentDetail] = useState(false);
  const [unitList, setunitList] = useState(false);
  const [display, setDisplay] = useState([]);
  const permission = user?.permission?.find(
    (e) => e.manager === "ads_and_banner_manager",
  );
  const handleFileChange = (e) => {
    const image = e?.target?.files[0];

    const isValidImage = handleFileUploadSingle(e);
    if (isValidImage) {
      if (e?.target?.name === "bannerImage") {
        setBannerImage(image);
        setBannerImageError("");
      } else if (e?.target?.name === "mobileBannerImage") {
        setBannerMobileImage(image);
        setBannerMobileImageError("");
      }
    }
  };
  const selected = (checkedArray) => {
    const isBuySelected = checkedArray?.some((item) => item === "buy");
    if (isBuySelected) setIsBuy(isBuySelected);
    const isRentSelected = checkedArray?.some((item) => item === "rent");
    if (isRentSelected) setIsRent(isRentSelected);
    const isCommercialSelected = checkedArray?.some(
      (item) => item === "commercial",
    );
    if (isCommercialSelected) setIsCommercial(isCommercialSelected);
    const isPropertySelected = checkedArray?.some(
      (item) => item === "propertyDetail",
    );
    if (isPropertySelected) setPropertyDetail(isPropertySelected);
    const isProjectSelected = checkedArray?.some(
      (item) => item === "projectDetail",
    );
    if (isProjectSelected) setProjectDetail(isPropertySelected);
    const isProjectListSelected = checkedArray?.some(
      (item) => item === "projectList",
    );
    if (isProjectListSelected) setProjectList(isProjectListSelected);
    const isAgentSelected = checkedArray?.some(
      (item) => item === "agentDetail",
    );
    if (isAgentSelected) setAgentDetail(isAgentSelected);
    const isUnitListSelected = checkedArray?.some(
      (item) => item === "unitList",
    );
    if (isUnitListSelected) setunitList(isUnitListSelected);
  };
  const sideBanner = async () => {
    try {
      const path = apiPath.getSideBanner;
      const result = await apiGet(path);

      const response = result?.data?.results;

      setSideBanner(response);
      setValue("description", response?.description);
      setValue("descriptionAr", response?.descriptionAr);
      setValue("redirectLink", response?.redirectLink);
      setBannerImage(response?.bannerImage);
      setBannerMobileImage(response?.mobileBannerImage);
      if (response.display) {
        setDisplay(JSON.parse(response?.display));
        const checkedArray = JSON.parse(response?.display);
        selected(checkedArray);
      }
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      description: sidesBanner?.description,
    },
  });
  const checkValidation = () => {
    let isValid = true;
    if (!bannerImage) {
      isValid = false;
      setBannerImageError("Please select web banner image.");
    }
    if (!mobileBannerImage) {
      isValid = false;
      setBannerMobileImageError("Please select mobile banner image.");
    }
    return isValid;
  };
  const onSubmit = async (data) => {
    try {
      const isValid = checkValidation();
      if (!isValid) {
        return;
      }
      const formData = new FormData();
      formData.append("description", data.description);
      formData.append("descriptionAr", data.descriptionAr);
      formData.append("bannerImage", bannerImage);
      formData.append("mobileBannerImage", mobileBannerImage);
      formData.append("redirectLink", data.redirectLink);
      if (display.length > 0)
        formData.append("display", JSON.stringify(display));
      reset();
      const res = await apiPost(
        apiPath[!addHomeBanner ? "editSideBanner" : "homeBannerAdd"],
        formData,
      );
      if (res.data) {
        if (res.data.success) {
          sideBanner();
          notification.success(res.data.message);
          setBannerImage(res.data.results?.bannerImage);
        }
        if (addHomeBanner) {
          addHomeBanner.fn(false);
        }
      }
    } catch (err) {
      console.error("err:", err);
    }
  };

  const handleFileUploadSingle = (e) => {
    const getType = e.target.files[0].type.split("/");
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2);
    if (
      getType[1] !== undefined &&
      (getType[1] === "jpeg" ||
        getType[1] === "png" ||
        getType[1] === "jpg" ||
        getType[1] === "gif")
    ) {
      if (fileSize > 2) {
        notification.error("Please select image below 2 MB");
        return false;
      }
      return true;
    } else {
      notification.error("Only jpeg,png,jpg,gif formats are allowed");
    }
  };

  const onChecked = (event) => {
    if (event.target.checked) {
      if (event.target.name === "buy") setIsBuy(true);
      if (event.target.name === "rent") setIsRent(true);
      if (event.target.name === "commercial") setIsCommercial(true);
      if (event.target.name === "propertyDetail") setPropertyDetail(true);
      if (event.target.name === "projectDetail") setProjectDetail(true);
      if (event.target.name === "agentDetail") setAgentDetail(true);
      if (event.target.name === "projectList") setProjectList(true);
      if (event.target.name === "unitList") setunitList(true);
      const checkPrevious = display.some((item) => item === event.target.name);
      if (!checkPrevious) {
        setDisplay([...display, event.target.name]);
      }
    } else {
      const targetValue = event.target.name;
      const newDisplay = display.filter((item) => item !== targetValue);
      setDisplay(newDisplay);
      if (event.target.name === "buy") setIsBuy(false);
      if (event.target.name === "rent") setIsRent(false);
      if (event.target.name === "commercial") setIsCommercial(false);
      if (event.target.name === "propertyDetail") setPropertyDetail(false);
      if (event.target.name === "projectDetail") setProjectDetail(false);
      if (event.target.name === "agentDetail") setAgentDetail(false);
      if (event.target.name === "projectList") setProjectList(false);
      if (event.target.name === "unitList") setunitList(false);
    }
  };
  useEffect(() => {
    sideBanner();
  }, []);

  // const bannerImageUrl =
  //   typeof bannerImage === 'object'
  //     ? URL.createObjectURL(bannerImage)
  //     : sidesBanner.bannerImage

  return (
    <div className="border-0 rounded-lg  relative flex flex-col w-full bg-white outline-none focus:outline-none">
      <div className="relative p-6 flex-auto">
        <div className="">
          <div className="flex">
            <div className="flex justify-center">
              <div className="flex-col border bg-white px-6 py-14 shadow-md rounded-[4px] max-w-[1000px] w-full">
                <div className="flex flex-wrap mb-4">
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="buy"
                      type="checkbox"
                      disabled={
                        !(
                          manager?.add ||
                          user?.role === "admin" ||
                          permission?.add
                        )
                      }
                      checked={isBuy}
                      id="buy"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="buy">
                      {t("O_BUY")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="rent"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={isRent}
                      id="rent"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="rent">
                      {t("O_RENT")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="commercial"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={isCommercial}
                      id="commercial"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="commercial">
                      {t("O_COMMERCIAL")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="propertyDetail"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={propertyDetail}
                      id="propertyDetail"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="propertyDetail">
                      {t("O_PROPERTY_DETAIL")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="projectDetail"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={projectDetail}
                      id="projectDetail"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="projectDetail">
                      {t("O_PROJECT_DETAIL")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="projectList"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={projectList}
                      id="projectList"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="projectList">
                      {t("O_PROJECT_LISTING")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="agentDetail"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={agentDetail}
                      id="agentDetail"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="agentDetail">
                      {t("O_AGENT_DETAIL")}
                    </label>
                  </div>
                  <div className="form-check flex items-center justify-center mr-4">
                    <input
                      name="unitList"
                      type="checkbox"
                      disabled={!(manager?.add || user?.role === "admin")}
                      checked={unitList}
                      id="unitList"
                      className="mr-3 w-5 h-5"
                      onChange={(e) => onChecked(e)}
                    />
                    <label className="form-check-label" for="unitList">
                      {t("O_UNIT_LISTING")}
                    </label>
                  </div>
                </div>
                <div className="flex flex-col text-sm rounded-md">
                  <OInputField
                    wrapperClassName=""
                    name="redirectLink"
                    inputLabel={
                      <>
                        {t("REFERENCE_LINK")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    disabled={
                      !(
                        manager?.add ||
                        user?.role === "admin" ||
                        permission?.add
                      )
                    }
                    type="text"
                    autoFocus
                    register={register(
                      "redirectLink",
                      formValidation.redirectLink,
                    )}
                    errors={errors}
                  />
                  <OTextArea
                    wrapperClassName="relative z-0 my-6 w-full group"
                    name="description"
                    inputLabel={
                      <>
                        {t("O_DESCRIPTION")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    disabled={
                      !(
                        manager?.add ||
                        user?.role === "admin" ||
                        permission?.add
                      )
                    }
                    type="textarea"
                    register={register("description", {
                      required: "Description is required.",
                      minLength: {
                        value: 2,
                        message: "Minimum length must be 2.",
                      },
                      validate: (value) => {
                        return !value ? "White spaces not allowed." : true;
                      },
                    })}
                    errors={errors}
                  />
                  <OTextArea
                    wrapperClassName="relative z-0 my-6 w-full group"
                    name="descriptionAr"
                    inputLabel={
                      <>
                        {t("O_DESCRIPTION") + t("O_ARABIC")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    disabled={
                      !(
                        manager?.add ||
                        user?.role === "admin" ||
                        permission?.add
                      )
                    }
                    type="textarea"
                    register={register("descriptionAr", {
                      required: "Description in arabic is required.",
                      minLength: {
                        value: 2,
                        message: "Minimum length must be 2.",
                      },
                      validate: (value) => {
                        return !value ? "White spaces not allowed." : true;
                      },
                    })}
                    errors={errors}
                  />
                </div>

                {(manager?.add || user?.role === "admin") && (
                  <div className="text-center">
                    <OButton
                      label={<>{t("O_UPDATE")}</>}
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                )}
                <div className="px-4 py-4 text-sm whitespace-nowrap">
                  <div className="flex">
                    <h4 className="text-gray-700 dark:text-gray-200 mr-3">
                      {t("O_LAST_UPDATED")}
                    </h4>
                    <p className="text-gray-500 dark:text-gray-400">
                      {helpers.dateFormat(sidesBanner?.updatedAt)}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              {(bannerImage || sidesBanner.bannerImage) && (
                <>
                  <div className="w-[375px] ml-4 h-[750px]">
                    <h2 className="text-2xl pb-2">
                      {" "}
                      <strong>Website Image</strong>
                    </h2>
                    <label className="mb-2 block">
                      Image Resolution (9:16) (Vertical)
                    </label>
                    {!bannerImage ? (
                      <>
                        <div
                          id="FileUpload"
                          className="relative mb-5.5 block w-full cursor-pointer appearance-none rounded border-2 border-dashed border-primary bg-gray py-5 px-4 dark:bg-meta-4 sm:py-7.5"
                        >
                          <input
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                            onChange={handleFileChange}
                            name="bannerImage"
                            className="absolute inset-0 z-50 m-0 h-full w-full cursor-pointer p-0 opacity-0 outline-none"
                          />
                          <div className="flex flex-col items-center justify-center space-y-3">
                            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-stroke bg-white dark:border-strokedark dark:bg-boxdark">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                                  fill="#3C50E0"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                                  fill="#3C50E0"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                                  fill="#3C50E0"
                                />
                              </svg>
                            </span>
                            <p className="font-medium text-sm">
                              <span className="text-primary">
                                Click to upload
                              </span>
                              {/* or drag and drop */}
                            </p>
                            {/* <p className='mt-1.5 font-medium text-sm'>
                    SVG, PNG, JPG or GIF
                  </p>
                  <p className='font-medium text-sm'>(max, 800 X 800px)</p> */}
                          </div>
                        </div>
                        {bannerImageError && (
                          <ErrorMessage message={bannerImageError} />
                        )}
                      </>
                    ) : (
                      <>
                        <div className="border h-full  rounded-md relative">
                          <button
                            className=" flex items-center justify-center text-white rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none absolute top-[-4px] right-[0px]   w-[40px] h-[40px]"
                            onClick={() => setBannerImage("")}
                            disabled={!(manager?.add || user?.role === "admin")}
                          >
                            <span className="  text-2xl " title="Delete">
                              <MdCancel />
                            </span>
                          </button>

                          <input
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                            name="bannerImage"
                            ref={bannerImageRef}
                            onChange={handleFileChange}
                            className="hidden"
                          />
                          <OImage
                            src={
                              typeof bannerImage === "object"
                                ? URL.createObjectURL(bannerImage)
                                : sidesBanner.bannerImage
                            }
                            fallbackUrl={noImage}
                            className="w-full h-full object-cover"
                            alt=""
                          />
                          <button
                            type="button"
                            className=" align-center absolute top-0 end-0 p-3 rounded bg-black text-white cursor-pointer"
                            onClick={() => bannerImageRef?.current?.click()}
                            disabled={!(manager?.add || user?.role === "admin")}
                          >
                            <AiFillCamera />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-center">
              <>
                <div className="min-w-[500px] max-w-[500px] ml-4 h-[750px]">
                  <h2 className="text-2xl pb-2">
                    {" "}
                    <strong>Mobile Image</strong>
                  </h2>
                  <label className="mb-2 block">
                    Image Resolution (16:9) (Horizontal)
                  </label>
                  {!mobileBannerImage ? (
                    <>
                      <div
                        id="FileUpload"
                        className="relative mb-5.5 block w-full cursor-pointer appearance-none rounded border-2 border-dashed border-primary bg-gray py-5 px-4 dark:bg-meta-4 sm:py-7.5"
                      >
                        <input
                          type="file"
                          accept="image/*"
                          name="mobileBannerImage"
                          onChange={handleFileChange}
                          className="absolute inset-0 z-50 m-0 h-full w-full cursor-pointer p-0 opacity-0 outline-none"
                        />
                        <div className="flex flex-col items-center justify-center space-y-3">
                          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-stroke bg-white dark:border-strokedark dark:bg-boxdark">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                                fill="#3C50E0"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                                fill="#3C50E0"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                                fill="#3C50E0"
                              />
                            </svg>
                          </span>
                          <p className="font-medium text-sm">
                            <span className="text-primary">
                              Click to upload
                            </span>
                          </p>
                        </div>
                      </div>
                      {bannerMobileImageError && (
                        <ErrorMessage message={bannerMobileImageError} />
                      )}
                    </>
                  ) : (
                    <>
                      <div className=" border  h-[300px] rounded-md relative">
                        <button
                          className=" flex items-center justify-center text-white rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none absolute top-[-4px] right-[0px]   w-[40px] h-[40px]"
                          onClick={() => setBannerMobileImage("")}
                          disabled={!(manager?.add || user?.role === "admin")}
                        >
                          <span className="  text-2xl " title="Delete">
                            <MdCancel />
                          </span>
                        </button>
                        <input
                          type="file"
                          accept="image/png, image/jpg, image/jpeg"
                          name="mobileBannerImage"
                          ref={bannerMobileImageRef}
                          onChange={handleFileChange}
                          className="hidden"
                        />
                        <OImage
                          src={
                            typeof mobileBannerImage === "object"
                              ? URL.createObjectURL(mobileBannerImage)
                              : sidesBanner?.mobileBannerImage
                          }
                          fallbackUrl={noImage}
                          className="w-full h-full bg-cover"
                          alt=""
                        />
                        <button
                          type="button"
                          className=" align-center absolute top-0 end-0 p-3 rounded bg-black text-white cursor-pointer"
                          onClick={() => bannerMobileImageRef?.current?.click()}
                          disabled={!(manager?.add || user?.role === "admin")}
                        >
                          <AiFillCamera />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideAdsBanner;
